/*
 * Copyright (c) 2022 - present, Orangecells Innovation Lab Private Limited [https://orangecells.com]
 *
 * All rights reserved.
 */

import React from "react";

const Footer = () => {
  return (
    <footer className="bg-[#080C10] border-t border-[#1C2333] py-4 px-6 lg:px-20">
      <p className="font-['IBM_Plex_Mono'] text-xs text-[#8892A4] text-center">
        &copy; {new Date().getFullYear()} Orangecells Innovation Lab&nbsp;&nbsp;|&nbsp;&nbsp;All rights reserved
      </p>
    </footer>
  );
};

export default Footer;
